"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PlaceholderLabel = void 0;
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _defaultTheme = require("../../../../theme/defaultTheme/index.js");
var _getStyles = require("../../Typography/helper/getStyles.js");
const _excluded = ["color", "gutterBottom", "noWrap", "variant", "theme", "isFloatingLabel", "isLabelFloating", "fontFamily", "fontSize", "fontStyle", "fontWeight", "textTransformation", "textDecoration", "placeholderFontSize", "placeholderFontWeight", "placeholderLineHeight"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const PlaceholderLabel = exports.PlaceholderLabel = _styledComponents.default.p`
	${_ref => {
  let {
      color,
      gutterBottom,
      noWrap,
      variant,
      theme,
      isFloatingLabel,
      isLabelFloating,
      fontFamily = theme.typography.fontFamily,
      fontSize,
      fontStyle,
      fontWeight,
      textTransformation,
      textDecoration,
      placeholderFontSize,
      placeholderFontWeight,
      placeholderLineHeight
    } = _ref,
    props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
  const style = (0, _getStyles.getTypographyStyle)(variant, theme);
  const fontWeightValue = fontWeight ? fontWeight : style.fontWeight ? style.fontWeight : '';
  const fontSizeValue = isFloatingLabel && isLabelFloating ? '12px' : '14px';
  return `
			color: ${color};
            font-family:${fontFamily};
			background-color: ${isFloatingLabel && isLabelFloating ? theme.color.primaryBgColor : 'transparent'};
			line-height: ${placeholderLineHeight ? placeholderLineHeight : style.lineHeight};
            ${isFloatingLabel && isLabelFloating ? (0, _styledComponents.css)`
							top: 0px;
							left: 15px;
							background-color: ${theme.color.primaryBgColor};
							font-size: ${placeholderFontSize ? placeholderFontSize : '12px'};
							color: ${theme.color.black};
							cursor: ${isLabelFloating ? 'default' : 'text'};
							position: absolute;
							transform: translate(0, -50%);
							font-size: 12px;
							fontweight: ${placeholderFontWeight ? placeholderFontWeight : '400'};
					  ` : (0, _styledComponents.css)`
							font-size: 14px;
					  `};
            transition: 0.2s ease all;
            padding: 0px 2px;
			${gutterBottom ? 'margin-bottom: 1em;' : ''}
			${noWrap ? 'white-space: nowrap;' : ''}
            font-weight:${fontWeightValue};
			font-size:${fontSize ? fontSize : fontSizeValue} !important;
			font-style: ${fontStyle};
			text-transform:${textTransformation};
			text-decoration:${textDecoration == 'strike_of' ? 'line-through' : textDecoration == 'underline_overline' ? 'underline overline' : textDecoration};
			
		`;
}}
`;
PlaceholderLabel.defaultProps = {
  theme: _defaultTheme.theme
};